__turbopack_context__.v({
  "bar": "FocusSplit-module__Fpo2wW__bar",
  "dot": "FocusSplit-module__Fpo2wW__dot",
  "item": "FocusSplit-module__Fpo2wW__item",
  "legend": "FocusSplit-module__Fpo2wW__legend",
  "pct": "FocusSplit-module__Fpo2wW__pct",
  "segment": "FocusSplit-module__Fpo2wW__segment",
  "split": "FocusSplit-module__Fpo2wW__split",
});
